import { ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';
import { bookingsLoginUserAccountSeeAllServicesClick } from '@wix/bi-logger-wixboost-ugc/v2';
import { navigateToCalendarPage } from '@wix/bookings-catalog-calendar-viewer-navigation';
import {
  BookingsGroup,
  CancelModalClickValues,
  MemberAreaClickActions,
  RescheduleButtonOrigin,
} from '../../types';
import { getBasket } from '../../utils/mappers/bookings-mapper/bookings-mapper';
import { CreateActionParams } from '../actions';
import { ExperimentsConsts } from '../../consts/experiments';

export type ClickOnReschedule = (args: {
  group: BookingsGroup;
  origin: RescheduleButtonOrigin;
}) => void;

export function createClickOnRescheduleAction({
  getControllerState,
  context,
}: CreateActionParams): ClickOnReschedule {
  return async ({ group, origin }) => {
    const { flowAPI, biLogger, api } = context;
    const { wixCodeApi, platformAPIs } = flowAPI.controllerConfig;
    const [state] = getControllerState();
    const slug = group.bookings[0].service?.mainSlug?.name;
    const service = group.bookings[0].service;
    const order = group.order;
    const isAppointmentWithAddOns =
      service?.type === ServiceType.APPOINTMENT &&
      !!service?.addOnDetails?.length;

    const selectedTab = state.selectedTab.type;

    if (origin === RescheduleButtonOrigin.ActionMenu) {
      biLogger?.report(
        bookingsLoginUserAccountSeeAllServicesClick({
          action: MemberAreaClickActions.Reschedule,
          extraInfo: JSON.stringify({
            serviceId: group.bookings[0].service?.id,
            contactId: group.bookings[0].contactId,
          }),
          bookingId: group.bookings[0].bookingId,
          referralInfo: selectedTab,
        }),
      );
    } else if (origin === RescheduleButtonOrigin.CancellationModal) {
      if (biLogger) {
        api.logCancelBi({
          biLogger,
          selectedTab,
          clickValue: CancelModalClickValues.Reschedule,
        });
      }
    }
    const isRemoveSkipPreferencesModalParamEnabled =
      flowAPI.experiments.enabled(
        ExperimentsConsts.RemoveSkipPreferencesModalParam,
      );

    try {
      await navigateToCalendarPage(wixCodeApi, platformAPIs as any, {
        serviceSlugOrBasket: isAppointmentWithAddOns
          ? getBasket({ service, order })
          : slug,
        navigationContext: {
          bookingId: group.bookings[0].bookingId,
          ...(!isRemoveSkipPreferencesModalParamEnabled && {
            skipPreferencesModal: true,
          }),
        },
      });
    } catch {
      wixCodeApi.location.to?.('/');
    }
  };
}
